import { React, PT, fetchApi } from '@gasbuddy/react';
import { Header, Button, Modal, Icon, Form, Input, Dropdown } from 'semantic-ui-react';

const stateOptions = [
  { key: 'AL', value: 'AL', text: 'Alabama' },
  { key: 'AK', value: 'AK', text: 'Alaska' },
  { key: 'AZ', value: 'AZ', text: 'Arizona' },
  { key: 'AR', value: 'AR', text: 'Arkansas' },
  { key: 'CA', value: 'CA', text: 'California' },
  { key: 'CO', value: 'CO', text: 'Colorado' },
  { key: 'CT', value: 'CT', text: 'Connecticut' },
  { key: 'DE', value: 'DE', text: 'Delaware' },
  { key: 'DC', value: 'DC', text: 'District Of Columbia' },
  { key: 'FL', value: 'FL', text: 'Florida' },
  { key: 'GA', value: 'GA', text: 'Georgia' },
  { key: 'HI', value: 'HI', text: 'Hawaii' },
  { key: 'ID', value: 'ID', text: 'Idaho' },
  { key: 'IL', value: 'IL', text: 'Illinois' },
  { key: 'IN', value: 'IN', text: 'Indiana' },
  { key: 'IA', value: 'IA', text: 'Iowa' },
  { key: 'KS', value: 'KS', text: 'Kansas' },
  { key: 'KY', value: 'KY', text: 'Kentucky' },
  { key: 'LA', value: 'LA', text: 'Louisiana' },
  { key: 'ME', value: 'ME', text: 'Maine' },
  { key: 'MD', value: 'MD', text: 'Maryland' },
  { key: 'MA', value: 'MA', text: 'Massachusetts' },
  { key: 'MI', value: 'MI', text: 'Michigan' },
  { key: 'MN', value: 'MN', text: 'Minnesota' },
  { key: 'MS', value: 'MS', text: 'Mississippi' },
  { key: 'MO', value: 'MO', text: 'Missouri' },
  { key: 'MT', value: 'MT', text: 'Montana' },
  { key: 'NE', value: 'NE', text: 'Nebraska' },
  { key: 'NV', value: 'NV', text: 'Nevada' },
  { key: 'NH', value: 'NH', text: 'New Hampshire' },
  { key: 'NJ', value: 'NJ', text: 'New Jersey' },
  { key: 'NM', value: 'NM', text: 'New Mexico' },
  { key: 'NY', value: 'NY', text: 'New York' },
  { key: 'NC', value: 'NC', text: 'North Carolina' },
  { key: 'ND', value: 'ND', text: 'North Dakota' },
  { key: 'OH', value: 'OH', text: 'Ohio' },
  { key: 'OK', value: 'OK', text: 'Oklahoma' },
  { key: 'OR', value: 'OR', text: 'Oregon' },
  { key: 'PA', value: 'PA', text: 'Pennsylvania' },
  { key: 'RI', value: 'RI', text: 'Rhode Island' },
  { key: 'SC', value: 'SC', text: 'South Carolina' },
  { key: 'SD', value: 'SD', text: 'South Dakota' },
  { key: 'TN', value: 'TN', text: 'Tennessee' },
  { key: 'TX', value: 'TX', text: 'Texas' },
  { key: 'UT', value: 'UT', text: 'Utah' },
  { key: 'VT', value: 'VT', text: 'Vermont' },
  { key: 'VA', value: 'VA', text: 'Virginia' },
  { key: 'WA', value: 'WA', text: 'Washington' },
  { key: 'WV', value: 'WV', text: 'West Virginia' },
  { key: 'WI', value: 'WI', text: 'Wisconsin' },
  { key: 'WY', value: 'WY', text: 'Wyoming' },
];

const defaultState = {
  loading: false,
  opened: false,
  street1: '',
  street2: '',
  region: '',
  locality: '',
  postal_code: '',
  shipVia: '',
};

const isPwGBCard = instrument => !!(instrument && instrument.provider_name === 'gasbuddy'
  && instrument.instrument_type === 'private_card');

const isPwGBPlusCard = instrument => !!(instrument && instrument.provider_name === 'pdi'
  && instrument.instrument_type === 'private_card');

export class ShipModal extends React.Component {
  state = defaultState

  onChange = (field, value) => {
    this.setState({ [field]: value });
  }

  loadAndGo = () => {
    const { mapId } = this.props;
    this.setState({ opened: true, loading: true }, async () => {
      const { body: addr } = await fetchApi({
        url: `/payments/instrument/shipping-info/${mapId}`,
        catchErrors: true,
      });
      const newState = {
        loading: false,
      };
      if (addr) {
        Object.assign(newState, {
          street1: addr.street1,
          street2: addr.street2,
          locality: addr.locality,
          region: addr.region,
          postal_code: addr.postal_code,
        });
      }
      this.setState(newState);
    });
  }

  renewInstrument = () => {
    const { mapId } = this.props;
    this.setState({ loading: true }, async () => {
      const { street1, street2, locality, region, postal_code: pc } = this.state;
      const { status, error } = await fetchApi({
        url: `/payments/instrument/renew/${mapId}`,
        catchErrors: true,
        body: {
          street1,
          street2,
          locality,
          region,
          postal_code: pc,
          country: 'US',
        },
      });
      if (status === 200) {
        this.setState(defaultState);
      } else {
        // eslint-disable-next-line no-alert, no-undef
        alert(`Failed to create shipment: ${status} ${error}`);
      }
    });
  }

  fraudShipInstrument = () => {
    const { instrument: { instrument_id: instrumentId, account_id: accountId } } = this.props;
    this.setState({ loading: true }, async () => {
      const { street1, street2, locality, region, postal_code: pc } = this.state;
      const { status, error } = await fetchApi({
        url: `/payments/instrument/reissue/${accountId}/${instrumentId}`,
        catchErrors: true,
        body: {
          reason: 'skimmed',
          newAddress: {
            line_1: street1,
            line_2: street2,
            locality,
            region,
            postal_code: pc,
            country: 'US',
          },
        },
      });
      if (status === 200) {
        this.setState(defaultState);
      } else {
        // eslint-disable-next-line no-alert, no-undef
        alert(`Failed to create shipment: ${error.status} ${error}`);
      }
    });
  }

  shipInstrument = () => {
    const { mapId } = this.props;
    this.setState({ loading: true }, async () => {
      const { street1, street2, locality, region, postal_code: pc, shipVia } = this.state;
      const { status, error } = await fetchApi({
        url: `/payments/instrument/create-shipment/${mapId}`,
        catchErrors: true,
        body: {
          street1,
          street2,
          locality,
          region,
          postal_code: pc,
          country: 'US',
          personalizationData: {
            ship: shipVia,
          },
        },
      });
      if (status === 201) {
        this.setState(defaultState);
      } else {
        // eslint-disable-next-line no-alert, no-undef
        alert(`Failed to create shipment: ${error.status} ${error}`);
      }
    });
  }

  render() {
    const { renewal, instrument } = this.props;
    const {
      opened, loading, street1, street2, locality,
      region, shipVia, postal_code: postalCode,
    } = this.state;
    const isPwGBPlus = isPwGBPlusCard(instrument);
    const isPwGB = isPwGBCard(instrument);
    return (
      <Modal
        open={opened}
        trigger={(isPwGB && <Button onClick={this.loadAndGo}>{renewal ? 'Renew Card' : 'Re-ship Card'}</Button>)
        || (isPwGBPlus && <Button onClick={this.loadAndGo}>Re-ship Card (Fraud)</Button>)}
      >
        <Header icon="attention" content="Enter or Confirm the Shipping Address" />
        <Modal.Content>
          <Form loading={loading}>
            <Form.Field>
              <Input
                name="line_1"
                value={street1}
                onChange={(e, { value }) => this.onChange('street1', value)}
                placeholder="Address 1"
              />
            </Form.Field>
            <Form.Field>
              <Input
                name="line_2"
                value={street2}
                placeholder="Address 2"
                onChange={(e, { value }) => this.onChange('street2', value)}
              />
            </Form.Field>
            <Form.Group widths="equal">
              <Form.Field>
                <Input
                  name="locality"
                  value={locality}
                  placeholder="City"
                  onChange={(e, { value }) => this.onChange('locality', value)}
                />
              </Form.Field>
              <Form.Field>
                <Dropdown
                  id="region"
                  placeholder="State"
                  value={region}
                  ref={(v) => { this.regionSelect = v; }}
                  options={stateOptions}
                  onChange={(e, el) => this.onChange('region', el.value)}
                  search
                  selection
                />
              </Form.Field>
              <Form.Field>
                <Input
                  name="postal_code"
                  placeholder="Zip Code"
                  value={postalCode}
                  onChange={(e, { value }) => this.onChange('postal_code', value)}
                />
              </Form.Field>
            </Form.Group>
            {!renewal && (
              <Form.Field inline>
                { /* eslint-disable-next-line max-len */ }
                { /* eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */ }
                <label htmlFor="shipVia">Ship Via</label>
                <Dropdown
                  id="shipVia"
                  defaultValue=""
                  options={[
                    { value: '', text: 'No Handling' },
                    { value: 'FedexFirst', text: 'FedEx First' },
                    { value: 'Fedex2Day', text: 'Fedex 2 Day' },
                  ]}
                  value={shipVia}
                  onChange={(e, { value }) => this.onChange('shipVia', value)}
                />
              </Form.Field>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
Cancel
          </Button>
          {isPwGB && (
            <Button basic color="red" onClick={renewal ? this.renewInstrument : this.shipInstrument}>
              <Icon name="mail" />
              {' '}
Ship Card
            </Button>
          )}
          {isPwGBPlus && (
            <Button basic color="red" onClick={this.fraudShipInstrument}>
              <Icon name="mail" />
              {' '}
Ship Card (Fraud)
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    );
  }
}

ShipModal.propTypes = {
  mapId: PT.string,
  renewal: PT.bool,
  instrument: PT.shape({
    instrument_id: PT.number,
    account_id: PT.number,
  }),
};

ShipModal.defaultProps = {
  mapId: null,
  renewal: false,
  instrument: {
    instrument_id: null,
    account_id: null,
  },
};
